import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Button } from "../components/ui/button";

export default function LibraryItemPage() {
  const { id } = useParams();

  const [item, setItem] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get(`/api/generations/${id}`);
        setItem(res.data);
      } catch (e) {
        setErr(e?.response?.data?.detail || "Failed to load generation.");
      }
    })();
  }, [id]);

  return (
    <div className="space-y-4" data-testid="library-item-page">
      <div className="flex items-center justify-between">
        <div className="text-2xl font-semibold">Library Item</div>
        <Link to="/app/library">
          <Button variant="outline">Back to Library</Button>
        </Link>
      </div>

      {err && (
        <Card className="border-red-200 bg-red-50">
          <CardContent className="py-3 text-sm text-red-700">{err}</CardContent>
        </Card>
      )}

      {item && (
        <Card>
          <CardHeader>
            <CardTitle className="text-base">{item.type || "generation"}</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            {item.output_json?.avatar && (
              <div className="rounded-lg border p-3">
                <div className="font-medium">AI Presenter</div>
                <div className="text-sm text-muted-foreground">
                  {item.output_json.avatar.presenter} • {item.output_json.avatar.style}
                </div>
                <div className="text-xs text-muted-foreground">
                  Avatar: {item.output_json.avatar.avatar_id}
                </div>
              </div>
            )}
            <pre className="max-h-[700px] overflow-auto text-xs leading-relaxed bg-muted p-4 rounded-lg">
              {JSON.stringify(item.output_json ?? item, null, 2)}
            </pre>
          </CardContent>
        </Card>
      )}
    </div>
  );
}
